
define('text!templates/modules/member/supervisors/new-messages.html',[],function () { return '<div class="new-message-list"></div>\n<div class="btn-clear-messages"></div>\n';});

